import { createStore } from 'satcheljs';
export default createStore('readingPaneOption', {
    readingPanePosition: null,
    nextSelection: null,
    loadMessageOnLogOn: null,
})();
//# sourceMappingURL=store.js.map